export const getVariantStyles = (variant, theme) => {
  const tokens = {
    default: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `1px dashed ${theme.color['fill-accent-neutral-hover']}`,
      color: theme.color['icon-core-default'],
      iconColor: 'icon-core-default'
    },
    hover: {
      backgroundColor: theme.color['fill-secondary-subtle'],
      border: `1px dashed ${theme.color['fill-secondary-default']}`,
      color: theme.color['icon-core-default'],
      iconColor: 'icon-interactive-default'
    },
    processing: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `1px solid ${theme.color['fill-surface-raised']}`,
      color: theme.color['icon-core-default'],
      iconColor: 'icon-core-default'
    },
    selected: {
      backgroundColor: theme.color['fill-surface-raised'],
      border: `1px solid ${theme.color['fill-surface-raised']}`,
      color: theme.color['fill-accent-neutral-pressed'],
      iconColor: 'fill-accent-neutral-pressed'
    },
    error: {
      backgroundColor: theme.color['fill-alert-subtle'],
      border: `1px dashed ${theme.color['fill-accent-red-pressed']}`,
      color: theme.color['fill-accent-neutral-pressed'],
      iconColor: 'fill-accent-red-pressed'
    },
    success: {
      backgroundColor: theme.color['fill-positive-subtle'],
      border: `1px dashed ${theme.color['fill-accent-green-pressed']}`,
      color: theme.color['fill-accent-neutral-pressed'],
      iconColor: 'fill-positive-default'
    }
  };
  return tokens[variant];
};
export const getIconSize = size => {
  switch (size) {
    case 'medium':
    case 'md':
    case 'large':
    case 'lg':
      return '800';
    case 'xs':
    case 'xl':
    case 'xxl':
    case 'small':
    case 'sm':
    default:
      return '600';
  }
};